<template>
  <div>
    <v-app class="p-4">
      <custom-popup
        v-model="showSingleImportModal"
        :cons="{ title: 'بارگیری تکی آگهی' }"
        hide-overlay
        hide-confirm
        max-width="500"
        transition="dialog-bottom-transition"
      >
        <v-card class="p-5">
          <v-select
            v-model="selectedNumberId"
            :items="numbers"
            item-value="id"
            label="شماره خود را انتخاب کنید"
            outlined
          >
            <template v-slot:item="data">
              <span> {{ data.item.phone }} - {{ data.item.nickname }} </span>
            </template>

            <template v-slot:selection="data">
              <span> {{ data.item.phone }} - {{ data.item.nickname }} </span>
            </template>
          </v-select>

          <v-text-field dense placeholder="لینک مدیریت آگهی" outline v-model="advertiseUrl" />

          <div class="row col justify-content-end mx-auto">
            <v-btn @click="singleImport" color="green" class="mr-auto" :loading="loading">
              <v-icon class="ml-2">mdi-import</v-icon>
              افزودن
            </v-btn>
          </div>
        </v-card>
      </custom-popup>
      <!--      start edit mode -->
      <template>
        <v-row justify="center">
          <v-dialog
            v-if="editModal"
            v-model="editModal"
            hide-overlay
            max-width="900"
            transition="dialog-bottom-transition"
          >
            <v-card>
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>ویرایش آگهی</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-toolbar-items>
                  <v-btn dark icon @click="editModal = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <EditAdvertise
                :modal="
                  () => {
                    this.editModal = false;
                  }
                "
                :token="editToken"
              ></EditAdvertise>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <!--      end edit mode -->

      <!--      start edit-panel mode -->
      <template>
        <v-row justify="center">
          <v-dialog
            v-if="editPanel"
            v-model="editPanel"
            hide-overlay
            max-width="900"
            transition="dialog-bottom-transition"
          >
            <v-card>
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>ویرایش آگهی</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-toolbar-items>
                  <v-btn dark icon @click="editPanel = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <edit-agency
                :editToken="editToken"
                :modal="
                  () => {
                    this.editPanel = false;
                  }
                "
                :type="AdsType"
              ></edit-agency>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <!--      end edit mode -->

      <!--      start chat mode -->
      <template>
        <v-row justify="center">
          <v-dialog
            v-if="chatModal"
            v-model="chatModal"
            hide-overlay
            max-width="900"
            transition="dialog-bottom-transition"
          >
            <v-card>
              <v-toolbar color="primary" dark>
                <v-toolbar-title>تاریخچه چت ها</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn dark icon @click="chatModal = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <myChat :UserID="UserID"></myChat>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <!--      end edit mode -->

      <v-dialog v-if="deleteDialog" v-model="deleteDialog" max-width="600px" scrollable>
        <template v-slot:activator="{ on, attrs }"> </template>
        <v-card>
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title> علت حذف آگهی خود را مشخص کنید.</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark icon @click="deleteDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text v-if="deleteDialog">
            <p class="mt-3">
              <span class="text-danger">توجه:</span> در صورت حذف آگهیِ منتشرشده تا ۲۴ ساعت امکان
              ارسال مجدد این آگهی را نخواهید داشت.
            </p>
            <v-radio-group column>
              <v-radio
                v-for="item in result.data"
                :key="item.id"
                :label="item.description"
                :value="item.reason"
                @change="getReason(item.reason)"
              ></v-radio>
            </v-radio-group>
          </v-card-text>
          <v-card-actions>
            <v-btn color="blue darken-1" text @click="deleteAds"> ذخیره </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--      start edit mode -->

      <custom-popup
        v-model="payModal"
        :cons="{ title: ' پرداخت و ارتقا' }"
        max-width="600"
        transition="dialog-bottom-transition"
      >
        <v-card class="pa-4" flat>
          <pay-upgrade
            :modal="
              () => {
                this.payModal = false;
              }
            "
            :token="token"
          />
        </v-card>
      </custom-popup>
      <!--      end edit mode -->
      <!--      start edit mode -->
      <v-dialog
        v-if="addTelePhone"
        v-model="addTelePhone"
        max-width="600"
        transition="dialog-bottom-transition"
      >
        <template>
          <v-card>
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title> اضافه کردن شماره ثابت</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn dark icon @click="addTelePhone = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>

            <v-card-text>
              <div class="text-h2 pa-12">
                <div class="row">
                  <div class="col-md-6">
                    <v-text-field
                      ref="sendPhone"
                      v-model="telephoneNumber"
                      :disabled="getConfirmCode"
                      :rules="rules"
                      counter="11"
                      dense
                      label="شماره تلفن ثابت"
                      maxlength="11"
                      outlined
                      prepend-inner-icon="fa fa-pencil-alt"
                      @keypress="allowOnlyNumbers($event)"
                      @keypress.enter="addTelephone"
                    ></v-text-field>
                  </div>
                  <div class="col-md-6">
                    <v-text-field
                      ref="getCode"
                      v-model="code"
                      :disabled="getConfirmCode === false"
                      dense
                      label="کد تایید"
                      maxlength="6"
                      outlined
                      prepend-inner-icon="fa fa-pencil-alt"
                      type="number"
                      @keypress="allowOnlyNumbers($event)"
                      @keypress.enter="submitCode"
                    ></v-text-field>
                  </div>
                </div>
                <v-btn v-if="!getConfirmCode" class="btn-get-code float-left" @click="addTelephone">
                  <span class="fa fa-save ml-1"></span>
                  ارسال کد تایید
                </v-btn>
                <v-btn v-if="getConfirmCode" class="submit-btn float-left" @click="submitCode">
                  <span class="fa fa-save ml-1"></span>
                  ثبت کد تایید
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </template>
      </v-dialog>
      <!--      end edit mode -->
      <v-dialog v-model="moreInformation" max-width="600" transition="dialog-bottom-transition">
        <template>
          <v-card>
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>اطلاعات بیشتر</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn dark icon @click="moreInformation = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <div class="pa-12">
                <div v-for="(index, item) in adsInformation" class="border-bottom py-3">
                  <p class="d-block text-dark" style="font-size: 10pt">{{ item }} :</p>
                  <p style="font-size: 9pt; white-space: break-spaces">{{ index }}</p>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </template>
      </v-dialog>

      <v-dialog v-model="seen" max-width="600" transition="dialog-bottom-transition">
        <template>
          <v-card>
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>آمار بازدید</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn dark icon @click="seen = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <p v-if="Myseries.length <= 0" class="text-danger mt-5 text-center font-weight-bold">
                متاسفانه بازدیدی از این آگهی در بازه زمانی مربوطه وجود نداشته است.
              </p>
              <div id="chart" style="max-width: 650px; margin: 35px auto"></div>
            </v-card-text>
          </v-card>
        </template>
      </v-dialog>

      <div class="col-md-12 p-0 mx-auto mt-5" style="border: none !important">
        <div class="col-md col-12 mx-auto my-0 pt-0">
          <v-btn
            color="red"
            text="reza"
            class="border border-danger"
            @click="showSingleImportModal = true"
          >
            <i class="fa fa-link text-danger mx-2"></i>
            بارگیری تکی آگهی
          </v-btn>
        </div>

        <div>
          <div class="col-md-12 d-flex mx-0 px-0">
            <div class="col-md-5 mt-0 pt-2">
              <v-autocomplete
                v-if="!isMobile"
                :items="status"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                item-text="name"
                item-value="name"
                label="فیلتر وضعیت آگهی ها"
                outlined
                prepend-inner-icon="fa fa-pencil-alt"
                @change="changeStatus($event)"
              >
              </v-autocomplete>
            </div>
            <div class="col-md col-12 mx-auto my-0 pt-0">
              <v-btn
                :disabled="selectedADS.length < 1"
                class="btn-delete float-left"
                outlined
                rounded
                @click="deleteAll"
              >
                <span class="fa fa-trash-alt ml-1"></span>
                حذف گروهی آگهی
              </v-btn>

              <v-btn
                :disabled="selectedADS.length < 1"
                class="btn-delete float-left"
                outlined
                rounded
                @click="migrateToFile"
              >
                <span class="fa fa-share ml-1"></span>
                انتقال به فایل املاک
              </v-btn>
            </div>
          </div>
          <v-card :loading="loading" class="p-3 pt-0">
            <terminal-table
              v-if="isMobile"
              v-model="selectedADS"
              :currentPage="datas.current_page"
              :datas="datas"
              :getData="getDataForTable"
              :headers="columns"
              :options="tableProps"
              :pageCount="datas.last_page"
              :perPage="datas.per_page"
            >
              <template slot="filters">
                <v-autocomplete
                  :items="status"
                  clear-icon="mdi-close-circle-outline"
                  clearable
                  dense
                  item-text="name"
                  item-value="name"
                  label="فیلتر وضعیت آگهی ها"
                  outlined
                  prepend-inner-icon="fa fa-pencil-alt"
                  @change="changeStatus($event)"
                >
                </v-autocomplete>
              </template>
            </terminal-table>

            <data-table
              v-if="!isMobile"
              :columns="columns"
              :data="datas"
              :debounce-delay="3000"
              :loading="true"
              :orderBy="tableProps.column"
              :orderDir="tableProps.dir"
              :pagination="paginate"
              :per-page="[10, 25, 50, 100, 500]"
              :translate="translate"
              class="pt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
              @on-table-props-changed="reloadTable"
            >
              <template slot="filters" slot-scope="{ tableFilters, perPage }">
                <filters-table
                  v-model="searchBox"
                  @getInfo="
                    val => {
                      if (val) tableProps.search = searchBox.search;
                    }
                  "
                ></filters-table>
              </template>
            </data-table>
          </v-card>
        </div>
      </div>
    </v-app>
  </div>
</template>

<script>
import button from '@/view/pages/button';
import { dataTableProps } from '@/main';
import TitleRibbon from '@/view/pages/uiBeautifier/titleRibbon';
import createTarefe from '@/view/pages/tarefe/createTarefe';
import myChat from '@/view/pages/chats/myChatList';
import PayUpgrade from '@/view/pages/ads/adsList/payUpgrade';
import EditSimple from '@/view/pages/ads/singleAds/editSimple';
import { debounce } from '../../../../custom';
import EditAgency from '../singleAds/agency/editAgency';
import EditAdvertise from '../Edit/Advertise';
import FiltersTable from '@/components/Table/filtersTable';

export default {
  name: 'myAds',
  components: {
    FiltersTable,
    EditAdvertise,
    EditAgency,
    EditSimple,
    PayUpgrade,
    TitleRibbon,
    button,
    dataTableProps,
    createTarefe,
    myChat,
  },
  props: {
    editProps: {
      type: Object,
      default: () => ({}),
    },
    UserID: {
      type: Number,
      default: () => 0,
    },
    token: {
      type: String,
      default: () => '',
    },
    editToken: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      showSingleImportModal: false,
      selectedNumberId: undefined,
      advertiseUrl: undefined,
      numbers: [],
      tarafeName: '',
      AdsType: '',
      deleteDialog: false,
      editPanel: false,
      seen: false,
      loading: false,
      moreInformation: false,
      selectedADS: [],
      status: [
        { name: 'منتشر شده' },
        { name: 'در صف انتشار' },
        { name: 'منقضی شده' },
        { name: 'حذف شده' },
        { name: 'رد شده' },
        { name: 'منتظر پرداخت' },
        { name: 'حذف شده' },
        { name: 'نیازبه اصلاح' },
        { name: 'فروشگاهی' },
      ],
      getConfirmCode: false,
      addTelePhone: false,
      rules: [v => v.length <= 11 || 'حداکثر رقم ورودی شما 11 رقم است'],
      editModal: false,
      result: {},
      chatModal: false,
      adsToken: '',
      code: '',
      editAds: false,
      mobile: false,
      provider: false,
      payModal: false,
      myStatus: '',
      finalReason: '',
      datas: {},
      translate: dataTableProps.translate,
      paginate: dataTableProps.pagination,
      tableProps: dataTableProps.tableProps,
      url: `${url}/advertise/list?status=`,
      selectedNumber: [],
      adsInformation: {
        'وضعیت آگهی': '',
        'وضعیت آگهی در دیوار': '',
        'توضیحات آگهی': '',
      },
      dataId: '',
      telephoneNumber: '',
      Myseries: [],
      columns: [
        {
          label: '<input type="checkbox" id="selectAll">',
          isCheckBox: true,
          transform: val => {
            return `<input type="checkbox" name="checkID"  data-id="${val.data.id}">`;
          },
          orderable: false,
        },
        {
          label: 'ردیف',
          transform: val => {
            let row = this.datas.current_page - 1;
            row = row * this.datas.per_page;
            return row + val.row + 1;
          },
          orderable: true,
        },
        {
          label: 'شناسه',
          name: 'id',
          transform: val => {
            const providers = {
              divar: 'شخصی',
              sheypoor: 'شخصی',
              divar_shop: 'فروشگاهی',
              divar_shop_pro: 'فروشگاهیPro',
              divar_real_estate: 'املاک',
              car_business: 'نمایشگاه',
            };

            return `<div class="flex">${
              val.data.id
            }</br><p class="badge badge-info font-weight-bold p-1">${
              providers[val.data.provider] || val.data.provider
            }</p></div>`;
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'شماره',
          name: 'number.phone',
          primary: true,
          transform: val => {
            return `${val?.data?.number?.phone}  ${
              val?.data?.number?.nickname != null ? ' - ' + val?.data?.number?.nickname : ''
            }`;
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'موضوع',
          name: 'title',
          orderable: true,
          searchable: true,
        },
        {
          label: 'تاریخ ارسال',
          name: 'created_at_p',
          orderable: true,
          searchable: true,
        },
        {
          label: 'تاریخ حذف',
          name: 'expire_at_p',
          transform: val => {
            if (val.expire_at) {
              return val.expire_at_p;
            } else {
              return '-';
            }
          },
          orderable: true,
        },
        {
          label: 'وضعیت',
          name: 'status',
          primary: true,
          transform: val => {
            const color = val.status !== 'success' ? 'green' : 'red';
            const text = val.status !== 'success' ? 'ارسال موفق' : 'ارسال ناموفق';
            return `<span class="badge badge-primary" style="background-color: ${color}">${text}</span>`;
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'وضعیت در دیوار',
          name: 'data.status',
          transform: val => {
            const color = val.data.data.hasOwnProperty('status')
              ? val.data.data.statusColor
              : 'blue';
            const text = val.data.data.hasOwnProperty('status') ? val.data.data.status : 'نامشخص';
            return `<span class="badge badge-primary" style="background-color: ${
              color || 'purple'
            }">${text || 'خطا در ثبت آگهی '}</span>`;
          },
          orderable: true,
        },
        {
          label: 'مدیریت',
          name: 'action',
          component: button,
          handler: this.actions,
          event: 'actions',
          meta: {
            buttons: [
              {
                name: 'delete',
                label: 'حذف آگهی',
                icon: 'trash-alt',
                class: 'btn-outline-danger',
                action: this.actions,
                status: 'divar_delete',
                condition: this.buttonsCondition,
              },
              {
                name: 'Edit',
                label: 'ویرایش آگهی',
                icon: 'pencil-alt',
                class: 'btn-outline-warning',
                action: this.actions,
                status: 'divar_update',
                condition: this.buttonsCondition,
              },
              {
                name: 'chat',
                label: 'تاریخچه چت',
                icon: 'comment-alt',
                class: 'btn-outline-info',
                action: this.actions,
                condition: this.buttonsCondition,
              },
              {
                name: 'payAndUpgrade',
                label: 'پرداخت و ارتقا',
                icon: 'dollar-sign',
                class: 'btn-outline-success',
                action: this.actions,
                condition: () => {
                  return true;
                },
              },

              {
                name: 'myAds',
                label: 'آگهی من',
                icon: 'search',
                class: 'btn-outline-primary',
                action: this.actions,
                status: 'divar_update',
                condition: this.buttonsCondition,
              },
              {
                name: 'seenAmar',
                label: 'آمار بازدیدها',
                icon: 'bars',
                class: 'btn-outline-primary',
                action: this.actions,
                status: 'divar_update',
                condition: this.buttonsCondition,
              },
              {
                name: 'moreInfo',
                label: 'اطلاعات بیشتر',
                icon: 'info-circle',
                class: 'btn-outline-primary',
                action: this.actions,
                status: 'divar_update',
                condition(status) {
                  return true;
                },
              },

              {
                name: 'addTelephone',
                label: 'افزودن شماره ثابت',
                icon: 'phone',
                class: 'btn-outline-success',
                action: this.actions,
                status: 'divar_update',
                condition: this.buttonsCondition,
              },
              // {
              //     name: 'reSend',
              //     label: 'ارسال مجدد',
              //     icon: 'paper-plane',
              //     class: 'btn-outline-success',
              //     action: this.actions,
              //     status: 'divar_update',
              //     condition(status) {
              //         return false;
              //     }
              // },
            ],
          },
        },
      ],
      chart: null,
      options: {
        chart: {
          height: 280,
          type: 'area',
          fill: 'red',
        },
        dataLabels: {
          enabled: false,
        },
        series: [
          {
            name: 'میزان بازدید در این روز',
            data: [0],
          },
        ],
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 90, 100],
          },
        },
        xaxis: {
          categories: [0],
        },
      },
      searchBox: {
        search: '',
        length: 10,
      },
    };
  },
  methods: {
    buttonsCondition(status) {
      return (
        ['آگهی توسط شما حذف شده است', 'رد شده', 'failed', 'نامشخص', 'منقضی شده', 'حذف شده'].indexOf(
          status
        ) <= -1
      );
    },
    getDataForTable(url = this.url, query = this.tableProps) {
      const vm = this;
      vm.loading = true;
      $.ajax({
        url: url,
        type: 'GET',
        fn: this.getDataForTable,
        data: Object.assign({}, query, {
          status: this.myStatus,
          search: this.tableProps.search,
          length: this.searchBox.length,
        }),
        headers: {
          ACCEPT: 'application/json',
          Authorization: Token,
        },
        success: function (data) {
          vm.datas = data;
          vm.loading = false;
        },
      });
    },
    reloadTable(tableProps) {
      debounce(() => {
        this.getDataForTable(this.url, tableProps);
      }, 1000);
    },
    getReason(reason) {
      this.finalReason = reason;
    },
    changeStatus: function (value) {
      this.myStatus = value;
      this.getDataForTable(this.url);
    },
    actions(data, type) {
      if (type === 'chat') {
        this.chatModal = true;
        this.UserID = data.id;
      } else if (type === 'payAndUpgrade') {
        this.payModal = true;
        this.token = data.manage_token;
      } else if (type === 'delete') {
        this.adsToken = data.manage_token;
        this.deleteDialog = true;
        $.ajax({
          url: `${url}/divar/advertise/delete/${this.adsToken}`,
          type: 'GET',
          fn: this.actions,
          headers: {
            ACCEPT: 'application/json',
            Authorization: Token,
          },
          success: data => {
            this.result = data;
          },
        });
      } else if (type === 'Edit') {
        this.editToken = data.manage_token;
        if (data.provider === 'divar_shop' || data.provider === 'divar_real_estate') {
          this.AdsType = data.provider;
          this.editPanel = true;
        } else this.editModal = true;
      } else if (type === 'myAds') {
        window.open(`https://divar.ir/v/${data.data.token}`, '_blank');
      } else if (type === 'addTelephone') {
        this.addTelePhone = true;
        this.adsToken = data.manage_token;
      } else if (type === 'moreInfo') {
        this.moreInformation = true;
        this.adsInformation['وضعیت آگهی در دیوار'] =
          (data.data.hasOwnProperty('status') ? data.data.status : 'نامشخص') +
          '\n' +
          (data.data.stateMessage ||
            (typeof data.data.errors !== 'object' ? data.data.errors : data.data.errors[0]) ||
            '');
        this.adsInformation['وضعیت آگهی'] =
          data.status === 'success' ? 'ارسال موفق' : 'ارسال ناموفق';
        this.adsInformation['توضیحات آگهی'] = data.description;
      } else if (type === 'seenAmar') {
        this.seen = true;
        this.editToken = data.manage_token;
        $.ajax({
          url: `${url}/divar/advertise/${this.editToken}/chart`,
          async: false,
          headers: {
            ACCEPT: 'application/json',
            Authorization: Token,
          },
          success: data => {
            this.Myseries = data.data;
          },
        });

        this.$nextTick(() => {
          this.options.series[0].data = this.Myseries.map(x => x.visits);
          this.options.xaxis.categories = this.Myseries.map(x => x.title);

          this.chart = new ApexCharts(document.querySelector('#chart'), this.options);
          this.chart.render();
        });
      } else if (type === 'reSend') {
        console.log(data);
        // todo ino yadet nare
      }
    },
    deleteAds() {
      if (this.finalReason !== '') {
        $.ajax({
          url: `${url}/divar/advertise/delete/${this.adsToken}/delete/${this.finalReason}`,
          type: 'POST',
          fn: this.deleteAds,
          headers: {
            ACCEPT: 'application/json',
            Authorization: Token,
          },
          data: {
            reason: this.finalReason,
          },
          success: data => {
            this.deleteDialog = false;
            this.adsToken = '';
            this.getDataForTable(this.url, this.tableProps);
          },
        });
      }
    },
    addTelephone() {
      $.ajax({
        url: `${url}/divar/landLine/${this.adsToken}/${this.telephoneNumber}`,
        type: 'POST',
        fn: this.actions,
        headers: {
          ACCEPT: 'application/json',
          Authorization: Token,
        },
        success: () => {
          this.getConfirmCode = true;
          this.$nextTick(() => {
            this.$modal.success('موفقیت آمیز!', 'کد تایید به زودی برای شما ارسال خواهد شد.');
          });
        },
      });
    },
    submitCode() {
      $.ajax({
        url: `${url}/divar/landLine/${this.adsToken}/${this.telephoneNumber}/${this.code}`,
        type: 'PUT',
        fn: this.actions,
        headers: {
          ACCEPT: 'application/json',
          Authorization: Token,
        },
        msg: true,
      });
    },
    deleteAll() {
      this.$modal.yesNo('تایید حذف گروهی', 'آیا از حذف آگهی های خود اطمینان دارید؟').then(value => {
        if (value === true) {
          $.ajax({
            url: `${url}/divar/advertise/delete/mass/F`,
            type: 'POST',
            fn: this.deleteAll,
            headers: {
              ACCEPT: 'application/json',
              Authorization: Token,
              'Content-Type': 'application/json',
            },
            data: JSON.stringify({
              post: this.selectedADS,
            }),
            msg: true,
            success: () => {
              this.selectedADS = [];
              this.reloadTable();
            },
          });
        }
      });
    },
    migrateToFile() {
      $.ajax({
        url: `${url}/divar/advertise/migrate/mass`,
        type: 'POST',
        fn: this.deleteAll,
        headers: {
          ACCEPT: 'application/json',
          Authorization: Token,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify({
          post: this.selectedADS,
        }),
        msg: true,
        success: () => {
          this.selectedADS = [];
        },
      });
    },
    allowOnlyNumbers(value) {
      let allowedKeys = [8, 46, 38, 40, 37, 39];
      const keypressed = value.which || value.keyCode;
      if (/[^0-9\s]+/.test(value.key)) {
        if (allowedKeys.every(e => e !== keypressed)) {
          value.preventDefault();
        }
      } else return true;
    },
    getNumberList() {
      this.loading = true;

      let url = `${window.url}/number?length=100000`;

      $.ajax({
        url: url,
        type: 'GET',
        headers: {
          ACCEPT: 'application/json',
          Authorization: Token,
        },
        success: data => {
          console.log(data.data);
          this.numbers = data.data;
          this.loading = false;
        },
      });
    },
    singleImport() {
      this.loading = true;
      $.ajax({
        url: `${url}/divar/import/${this.selectedNumberId}/single`,
        type: 'POST',
        data: { advertise: this.advertiseUrl },
        headers: {
          ACCEPT: 'application/json',
          Authorization: Token,
        },
        msg: true,
        success: () => {
          this.advertiseUrl = undefined;
        },
      }).always(() => {
        this.loading = false;
      });
    },
  },
  watch: {
    addTelePhone: function () {
      this.telephoneNumber = '';
      this.code = '';
      this.getConfirmCode = false;
      this.$nextTick(function () {
        this.$refs.sendPhone.focus();
      });
    },
    getConfirmCode: function () {
      setTimeout(() => {
        this.$refs.getCode.focus();
      }, 1500);
    },
    searchBox: {
      handler() {
        this.tableProps.length = this.searchBox.length;
      },
      deep: true,
    },
  },
  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          this.getDataForTable(this.url);
          return true;
        case 'sm':
          this.getDataForTable(this.url);
          return true;
        case 'md':
          this.getDataForTable(this.url);
          return false;
        case 'lg':
          this.getDataForTable(this.url);
          return false;
        case 'xl':
          this.getDataForTable(this.url);
          return false;
      }
    },
  },
  mounted() {
    this.tableProps = {
      search: '',
      length: 10,
      column: 'id',
      dir: 'desc',
      page: 1,
    };

    this.getDataForTable(this.url);

    $(document).on('click', '#selectAll', element => {
      if ($(element.target).is(':checked')) {
        $('input[type="checkbox"]').prop('checked', true);

        const selected = $('input[type="checkbox"]')
          .map(function () {
            return $(this).data('id');
          })
          .get();

        this.selectedADS = selected;
      } else {
        $('input[type="checkbox"]').prop('checked', false);
        this.selectedADS = [];
      }
    });

    $(document).on('click', `input[name = 'checkID']`, element => {
      if ($(element.target).is(':checked')) {
        const selectedPart = $(element.target).data('id');
        console.log($(element.target));
        this.selectedADS.push(selectedPart);
      } else {
        $(element.target).prop('checked', false);
        this.selectedADS.splice(this.selectedADS.indexOf($(this).data('id')), 1);
      }
    });

    this.getNumberList();
  },
};
</script>

<style scoped></style>
